import {atomWithStorage} from "jotai/vanilla/utils";

const midnight = new Date()
midnight.setHours(24, 0, 0, 0)

export const gamesLeftExpiryDateAtom = atomWithStorage<Date>("expiryDate", midnight)
// Initialize with -1 to indicate not yet loaded from remote config
export const gamesLeftAtom = atomWithStorage<number>("gamesLeft", -1)